import {
  LookParticle,
  LookParticleBreed,
} from "../anims/particles/LookParticle";
import { TargetInvalidParticleBreed } from "../anims/particles/TargetInvalidParticle";
import { TargetValidParticleBreed } from "../anims/particles/TargetValidParticle";
import { ParticleManager } from "../anims/particleSystem";
import { gameData } from "../GameManager";

export const setFocusToCursor = () => {
  if (gameData.focus) {
    if (gameData.focus) {
      gameData.focus.finish();
      gameData.focus = ParticleManager.createParticle(
        LookParticleBreed,
        gameData.focus.x,
        gameData.focus.y
      ) as LookParticle<void>;
    }
  }
};
export const setFocusToTarget = () => {
  if (gameData.target && gameData.focus) {
    if (gameData.target.validateRange(gameData.player.pieces, gameData.focus)) {
      gameData.focus.finish();
      gameData.focus = ParticleManager.createParticle(
        TargetValidParticleBreed,
        gameData.focus.x,
        gameData.focus.y
      ) as LookParticle<void>;
    } else {
      gameData.focus.finish();
      gameData.focus = ParticleManager.createParticle(
        TargetInvalidParticleBreed,
        gameData.focus.x,
        gameData.focus.y
      ) as LookParticle<void>;
    }
  }
};
